<template>
  <div>
    <Table
      resource="VoucherV2"
      :detail-route="row => `/v2/vouchers/${row.id}/detail`"
      :actions="actions"
      :items="$store.getters['voucherV2/tableData']"
      :detail="$store.getters['voucherV2/detailData']"
      :fields="$store.getters['voucherV2/tableFields']"
      :pagination="$store.state.voucherV2.tablePagination"
      :keyword="$store.state.voucherV2.tableKeyword"
      :loading="$store.state.voucherV2.loadingTable"
      :filter="$store.state.voucherV2.tableFilter"
      :sort="$store.state.voucherV2.tableSort"
      :sort-options="sortOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @delete="deleteData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
    />
  </div>
</template>

<script>
import Table from '@/layouts/components/v2/Table.vue'

export default {
  components: {
    Table,
  },
  data() {
    return {
      // Sort
      sortOptions: [
        {
          key: 'created_at', direction: 'desc', label: 'Terbaru', default: true,
        },
        { key: 'created_at', direction: 'asc', label: 'Terlama' },
      ],

      actions: [
        'create',
        'view',
        'update',
        'delete',
        {
          type: 'other',
          children: [
            {
              label: 'Penggunaan Voucher',
              event: data => this.viewVoucherUsage(data.item),
              visibility: {
                callback: data => Boolean(data && data.item && data.item.id),
              },
            },
          ],
        },
      ],
    }
  },
  methods: {
    loadData() {
      return this.$store.dispatch('voucherV2/getTableData')
    },
    loadDetail(id) {
      return this.$store.dispatch('voucherV2/getDetail', id)
    },
    deleteData(id, callback) {
      return this.$store.dispatch('voucherV2/delete', id)
        .then(() => {
          callback()
        })
        .catch(err => {
          callback(err)
        })
    },
    resetDetail() {
      this.$store.commit('voucherV2/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('voucherV2/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('voucherV2/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('voucherV2/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('voucherV2/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('voucherV2/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('voucherV2/SET_TABLE_KEYWORD', val)
    },
    viewVoucherUsage(voucher) {
      this.$router.push({
        name: 'voucher-usages-v2',
        params: { id: voucher.id },
      })
    },
  },
}
</script>
